import { render } from "./NamePlate.vue?vue&type=template&id=6c6a94b8&scoped=true"
import script from "./NamePlate.vue?vue&type=script&lang=js"
export * from "./NamePlate.vue?vue&type=script&lang=js"

import "./NamePlate.vue?vue&type=style&index=0&id=6c6a94b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6a94b8"]])

export default __exports__